// Coordinate existing mobile drawer lifecycles; animation remains in each drawer.
(() => {
  let sequence = 0;
  let pending = null;
  const activeDrawers = () => [...document.querySelectorAll(
    'header-drawer > details[open], heritage-search-modal > details[open], .facets-container .mobile-facets__disclosure[open], .styling-directory__drawer'
  )].filter((element) => !element.matches('.styling-directory__drawer') ||
    element.getAttribute('aria-hidden') === 'false' || document.documentElement.classList.contains('styling-filters-open'));
  const isActive = (element) => element.isConnected && (element.matches('.styling-directory__drawer')
    ? document.documentElement.classList.contains('styling-filters-open')
    : element.hasAttribute('open'));
  const closeAndWait = (element) => new Promise((resolve) => {
    const observer = new MutationObserver(() => {
      if (isActive(element)) return;
      observer.disconnect();
      resolve();
    });
    observer.observe(document.documentElement, { subtree: true, attributes: true, childList: true,
      attributeFilter: ['open', 'class', 'hidden', 'aria-hidden'] });
    if (element.matches('.styling-directory__drawer')) {
      if (element.getAttribute('aria-hidden') === 'false') element.dispatchEvent(new CustomEvent('heritage:drawer-close'));
    } else if (!element.classList.contains('is-closing')) {
      const search = element.closest('heritage-search-modal');
      if (search) search.close(false);
      else {
        const summary = element.querySelector(':scope > summary');
        element.closest('header-drawer, menu-drawer').closeMenuDrawer(new Event('click'), summary);
        summary.setAttribute('aria-expanded', 'false');
      }
    }
    if (!isActive(element)) { observer.disconnect(); resolve(); }
  });
  window.heritageCancelDrawerOpen = (target) => {
    if (pending !== target) return;
    sequence += 1;
    pending = null;
  };
  window.heritageOpenDrawer = (target, open) => {
    const request = ++sequence;
    pending = target;
    const blockers = activeDrawers().filter((element) => element !== target ||
      element.classList.contains('is-closing') || element.getAttribute('aria-hidden') === 'true');
    const finish = () => {
      if (request !== sequence || !target.isConnected) return;
      pending = null;
      open();
    };
    if (blockers.length) Promise.all(blockers.map(closeAndWait)).then(finish);
    else finish();
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const mobile = window.matchMedia('(max-width: 989px)');

  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    let timer;

    details.addEventListener('mouseenter', () => {
      if (!desktop.matches) return;
      window.clearTimeout(timer);
      details.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', () => {
      if (!desktop.matches) return;
      timer = window.setTimeout(() => details.removeAttribute('open'), 140);
    });

    details.addEventListener('focusin', () => {
      if (desktop.matches) details.setAttribute('open', '');
    });

    details.addEventListener('focusout', (event) => {
      if (desktop.matches && !details.contains(event.relatedTarget)) {
        details.removeAttribute('open');
      }
    });
  });

  const bindMobileAccordions = (root = document) => {
    root
      .querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li > details')
      .forEach((details) => {
        if (details.dataset.heritageAccordionBound === 'true') return;

        const summary = details.querySelector(':scope > summary');
        const panel = details.querySelector(':scope > .menu-drawer__submenu--accordion');

        if (!summary || !panel) return;

        if (['link-men', 'link-women', 'link-apparel'].includes(panel.id)) {
          panel.classList.remove('motion-reduce');
        }

        details.dataset.heritageAccordionBound = 'true';
        let timer;

        const finishOpen = () => {
          details.classList.remove('heritage-accordion-animating');
          panel.style.transition = 'none';
          panel.style.height = 'auto';
          panel.style.opacity = '1';
          panel.style.visibility = 'visible';
          panel.style.overflow = 'hidden';
          summary.setAttribute('aria-expanded', 'true');
        };

        const finishClosed = () => {
          details.classList.remove('heritage-accordion-animating');
          panel.style.transition = 'none';
          panel.style.height = '0px';
          panel.style.opacity = '0';
          panel.style.visibility = 'hidden';
          panel.style.overflow = 'hidden';
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        };

        if (details.open) {
          finishOpen();
        } else {
          finishClosed();
        }

        summary.addEventListener(
          'click',
          (event) => {
            if (!mobile.matches) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            window.clearTimeout(timer);
            details.classList.add('heritage-accordion-animating');

            const transition =
              'height 520ms cubic-bezier(.25, 1, .5, 1), opacity 420ms ease';

            if (details.open) {
              panel.style.transition = 'none';
              panel.style.height = panel.getBoundingClientRect().height + 'px';
              panel.style.opacity = '1';
              panel.style.visibility = 'visible';
              panel.offsetHeight;
              panel.style.transition = transition;

              window.requestAnimationFrame(() => {
                panel.style.height = '0px';
                panel.style.opacity = '0';
              });

              timer = window.setTimeout(finishClosed, 560);
            } else {
              details.setAttribute('open', '');
              panel.style.transition = 'none';
              panel.style.height = '0px';
              panel.style.opacity = '0';
              panel.style.visibility = 'visible';

              const targetHeight = panel.scrollHeight;

              panel.offsetHeight;
              panel.style.transition = transition;

              window.requestAnimationFrame(() => {
                panel.style.height = targetHeight + 'px';
                panel.style.opacity = '1';
              });

              timer = window.setTimeout(finishOpen, 560);
            }
          },
          true
        );
      });
  };

  bindMobileAccordions();

  document.addEventListener('shopify:section:load', (event) => {
    bindMobileAccordions(event.target);
  });
});

document.addEventListener('copy', (event) => {
  const target = event.target;

  if (
    !(target instanceof Element) ||
    !target.closest('input, textarea, select, [contenteditable="true"]')
  ) {
    event.preventDefault();
  }
});
(() => {
  const FILTER_CLOSE_MS = 650;

  const bindFilterDrawer = (drawer) => {
    let details = drawer.mainDetailsToggle || drawer.querySelector(':scope > details');
    let summary = details && details.querySelector(':scope > summary');
    if (!details || !summary) return;
    if (details.dataset.heritageFilterMotionBound === 'v2') return;

    if (details.dataset.heritageFilterMotionBound === 'true') {
      const next = summary.cloneNode(true);
      summary.replaceWith(next);
      summary = next;
    }

    details.dataset.heritageFilterMotionBound = 'v2';

    // Match the Styling Guide scrim: tapping outside the panel closes smoothly.
    if (details.closest('.facets-container')) {
      drawer.addEventListener('click', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches ||
            !event.target.matches('.mobile-facets') || !details.open || drawer._heritageClosing) return;
        event.preventDefault();
        drawer.closeMenuDrawer(event, summary);
        summary.setAttribute('aria-expanded', 'false');
      });
    }

    const onToggleIntent = (event) => {
      if (summary.parentNode !== details) return;
      if (event.target.closest('button, a, input, label')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      const isOpen = details.hasAttribute('open') && !details.classList.contains('is-closing');

      if (isOpen) {
        window.heritageCancelDrawerOpen(details);
        drawer.closeMenuDrawer(event, summary);
        summary.setAttribute('aria-expanded', 'false');
      } else {
        window.heritageOpenDrawer(details, () => {
          window.clearTimeout(drawer._heritageCloseTimer);
          details.classList.remove('is-closing');
          drawer._heritageClosing = false;
          details.setAttribute('open', '');
          drawer.openMenuDrawer(summary);
        });
      }
    };

    // Click covers touch, mouse and keyboard once; do not replay a stored DOM event.
    summary.addEventListener('click', onToggleIntent, { capture: true });

    details.addEventListener('toggle', () => {
      if (details.open) return;

      if (drawer._heritageClosing || details.classList.contains('is-closing') || details.classList.contains('menu-opening')) {
        details.setAttribute('open', '');
        if (!drawer._heritageClosing && details.classList.contains('menu-opening')) {
          drawer.closeMenuDrawer(new Event('click'), summary);
        }
      }
    });
  };

  const bindFilterDrawerMotion = (root = document) => {
    const MenuDrawer = customElements.get('menu-drawer');
    if (!MenuDrawer) return;

    if (!MenuDrawer.prototype.__heritageFilterMotionV2) {
      MenuDrawer.prototype.__heritageFilterMotionV2 = true;

      const originalCloseMenuDrawer = MenuDrawer.prototype.closeMenuDrawer;
      const originalBindEvents = MenuDrawer.prototype.bindEvents;

      MenuDrawer.prototype.closeAnimation = function (detailsElement) {
        window.clearTimeout(this._heritageCloseTimer);
        this._heritageCloseTimer = window.setTimeout(() => {
          detailsElement.removeAttribute('open');
          detailsElement.classList.remove('is-closing');
          this._heritageClosing = false;

          if (detailsElement.closest('details[open]')) {
            trapFocus(
              detailsElement.closest('details[open]'),
              detailsElement.querySelector('summary')
            );
          }
        }, FILTER_CLOSE_MS);
      };

      MenuDrawer.prototype.closeMenuDrawer = function (event, elementToFocus = false) {
        if (event === undefined) return;

        const details = this.mainDetailsToggle;
        if (details && !details.hasAttribute('open')) details.setAttribute('open', '');
        this._heritageClosing = true;
        if (details) details.classList.add('is-closing');

        return originalCloseMenuDrawer.call(this, event, elementToFocus);
      };

      MenuDrawer.prototype.bindEvents = function () {
        originalBindEvents.call(this);
        bindFilterDrawer(this);
      };
    }

    const drawers = root.matches?.('menu-drawer')
      ? [root]
      : [...root.querySelectorAll('menu-drawer')];
    drawers.forEach((drawer) => bindFilterDrawer(drawer));
  };

  const bindHeaderDrawer = (root = document) => {
    root.querySelectorAll('header-drawer').forEach((drawer) => {
      const details = drawer.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!summary || summary.dataset.heritageCoordinated) return;
      summary.dataset.heritageCoordinated = 'true';
      summary.addEventListener('click', (event) => {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (details.open && !details.classList.contains('is-closing')) {
          window.heritageCancelDrawerOpen(details);
          drawer.closeMenuDrawer(event, summary);
          summary.setAttribute('aria-expanded', 'false');
        } else {
          window.heritageOpenDrawer(details, () => {
            details.setAttribute('open', '');
            drawer.openMenuDrawer(summary);
          });
        }
      }, { capture: true });
    });
  };
  const start = () => { bindFilterDrawerMotion(); bindHeaderDrawer(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindFilterDrawerMotion(event.target);
    bindHeaderDrawer(event.target);
  });
})();
